
// This is an auto generated file - do not edit!
// Swagger path: /api/System/feature

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseApiService } from '../base-api.service';


@Injectable({ providedIn: 'root' })
export class SystemFeatureApiService extends BaseApiService {
    
    get(options = {}): Observable<any> {
        return this._get<any>(
            `/System/feature`,
            options
        );
    }
}
